import "../index.css";

export const MultipleInputBox = ({
  label,
  value,
  setValue,
  type,
  customStyle,
  secondValue,
  setSecondValue,
  secondType,
  thirdValue,
  setThirdValue,
  thirdType,
  isTextArea,
}) => {
  return (
    <div className="product-multiple-inputs-bg" style={{ ...customStyle }}>
      <p>{label}</p>

      {isTextArea ? (
        <textarea
          className="product-multiple-inputs-input"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
      ) : (
        <input
          className="product-multiple-inputs-input"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          type={type ? type : "number"}
          min={0}
        />
      )}

      {setSecondValue !== undefined && (
        <input
          className="product-multiple-inputs-input"
          value={secondValue || 0}
          onChange={(e) => setSecondValue(e.target.value)}
          type={secondType ? secondType : "number"}
          min={0}
        />
      )}

      {setThirdValue !== undefined && (
        <input
          className="product-multiple-inputs-input"
          value={thirdValue || 0}
          onChange={(e) => setThirdValue(e.target.value)}
          type={thirdType ? thirdType : "number"}
          min={0}
        />
      )}
    </div>
  );
};
